import React, { ReactNode } from "react";
import AppBox from "./Box";
import AppText from "./Text";

interface PillProps {
  label: string;
  icon?: ReactNode;
  varient?: "success" | "warning" | "danger";
  size?: "sm" | "md" | "lg";
}
export default function Pill({ label, icon, varient = "success", size = "sm" }: PillProps) {
  return (
    <AppBox alignItems="center" justifyContent="center" gap="3xs" className={`pill-${varient} pill-${size}`}>
      {icon && icon}
      <AppText size={size} className="pill-label">
        {label}
      </AppText>
    </AppBox>
  );
}
